export const TYPES = {
  FIREBASE_AUTH_STATUS: "bailiff_auth/FIREBASE_AUTH_STATUS",
  FIREBASE_AUTH_UID: "bailiff_auth/FIREBASE_AUTH_UID",
  FIREBASE_AUTH_PERMISSIONS: "bailiff_auth/FIREBASE_AUTH_PERMISSIONS",
  //
  FIREBASE_AUTH_REGISTER_SUCCESS: "bailiff_auth/FIREBASE_AUTH_REGISTER_SUCCESS",
  FIREBASE_AUTH_REGISTER_STEP: "bailiff_auth/FIREBASE_AUTH_REGISTER_STEP",
  FIREBASE_AUTH_REGISTER_LASTMAIL:
    "bailiff_auth/FIREBASE_AUTH_REGISTER_LASTMAIL",
};
